import ComponentLister from './lister.js';

export default class ArticleLister extends ComponentLister {
  constructor(
      prefix = 'blog',
      sComponentMethod = 'ArticleList::onGetJSONData',
      storeList = { published: null }
    ) {
    super(prefix, sComponentMethod, storeList);

    const listElement = this.findListElement();
    if (listElement) {
      const categoryId = listElement.getAttribute('data-category');
      if (categoryId) {
        storeList = { ...storeList, category: categoryId };
        this.setStoreList(storeList);
      }
    }

    this.obItemBindCallback = function bindArticleItem (item) {
      return {
          img: item.hasOwnProperty('attachOne|preview_image') ? item['attachOne|preview_image'].path : null,
          title: item.title,
          publishedstart: item.published_start_text,
          viewcount: item.view_count_text,
          previewtext: item.preview_text,
          url: item.slug
      };
    }
  }
}
